export function subscriptionRequest(state={
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SUBSCRIPTION_START":           
        case "DELETE_SUBSCRIPTION_START":           
        case "CHANGE_STOCK_SUBSCRIPTION_START":           
        case "UPDATE_SUBSCRIPTION_MINIPAYMENT_START":
            return {
                ...state, 
                fetching:true
            }        
        case "CREATE_SUBSCRIPTION_FULFILLED":           
        case "DELETE_SUBSCRIPTION_FULFILLED":           
        case "CHANGE_STOCK_SUBSCRIPTION_FULFILLED":           
        case "UPDATE_SUBSCRIPTION_MINIPAYMENT_FULFILLED":
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SUBSCRIPTION_ERROR":
        case "DELETE_SUBSCRIPTION_ERROR":
        case "CHANGE_STOCK_SUBSCRIPTION_ERROR":
        case "UPDATE_SUBSCRIPTION_MINIPAYMENT_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        // case "CHANGE_STOCK_SUBSCRIPTION_FULFILLED":
        // case "CHANGE_STOCK_SUBSCRIPTION_ERROR":
        default:
            return state;
    }
    
}